import React from "react";
import { useSelector } from "react-redux";
import { RootState } from "@src/reducers/store";
import { SupportChatModal } from "@src/components/organisms/modals/support-chat-modal/support-chat-modal";

export const SupportChat = () => {
  const isSupportChatOpen = useSelector(
    (state: RootState) => state.yourSlice.modals.supportChatDrawerModal.showModal,
  );

  return <>{isSupportChatOpen && <SupportChatModal />}</>;
};
